import { render, staticRenderFns } from "./addApiCate.vue?vue&type=template&id=47976ed4&scoped=true"
import script from "./addApiCate.vue?vue&type=script&lang=js"
export * from "./addApiCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47976ed4",
  null
  
)

export default component.exports